import { principles, testimonials, site } from "@/mocks/guaData";

const stats = [
  { num: "1200+", label: "累计盘点事件" },
  { num: "86", label: "周更专题" },
  { num: "4.9/5", label: "读者评价" },
  { num: "28万+", label: "月度阅读" },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-28 bg-paper-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-1 text-xs font-semibold tracking-[0.2em] text-primary-600">ABOUT US</div>
            <h2 className="font-serif text-2xl font-extrabold tracking-tight text-stone-900 md:text-3xl">关于瓜田速报</h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-stone-500">我们不生产瓜，只做瓜的「档案管理员」——把零散的碎片，整理成看得懂的脉络。</p>
        </div>

        {/* 品牌叙事 + 原则 */}
        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-lg border border-paper-200 bg-white p-6 md:p-7">
            <h3 className="font-serif text-lg font-bold text-stone-900">我们在做的事</h3>
            <p className="mt-3 text-sm leading-7 text-stone-600">
              {site.brand}诞生于一个简单的念头：刷热搜时，信息总是跳着来——今天看到结论，明天才知道起因。
              于是我们试着把每个被反复讨论的话题，用<b className="font-semibold text-primary-700">时间线</b>串起来，
              用可查证的公开信息<b className="font-semibold text-primary-700">还原过程</b>，
              用克制的表达<b className="font-semibold text-primary-700">避免结论先行</b>。
            </p>
            <p className="mt-3 text-sm leading-7 text-stone-600">
              我们希望你在快节奏的信息流里，也能拥有一个「慢下来看清楚」的角落。这里是读者共建的内容站，
              每一个事件的完整档案，都欢迎你补充线索、校正细节。
            </p>
            <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-md bg-paper-50 px-3 py-3 text-center">
                  <div className="font-serif text-xl font-extrabold text-primary-600">{s.num}</div>
                  <div className="mt-0.5 text-[11px] text-stone-500">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="grid gap-4">
            {principles.map((p) => (
              <div key={p.title} className="flex items-start gap-4 rounded-lg border border-paper-200 bg-white p-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 text-xl text-white">
                  <i className={p.icon} />
                </span>
                <div>
                  <h3 className="font-serif text-base font-bold text-stone-900">{p.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-stone-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 读者口碑 */}
        <div className="mt-8">
          <div className="mb-4 flex items-center gap-3">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-white"><i className="ri-quote-text" /></span>
            <h3 className="font-serif text-lg font-bold text-stone-900">读者怎么说</h3>
          </div>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            {testimonials.map((t) => (
              <figure key={t.name} className="flex flex-col justify-between rounded-lg border border-paper-200 bg-white p-5">
                <blockquote className="text-sm leading-relaxed text-stone-600">“{t.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-serif font-bold text-primary-700">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <div className="text-sm font-semibold text-stone-800">{t.name}</div>
                    <div className="text-[11px] text-stone-400">{t.role}</div>
                  </div>
                  <span className="ml-auto flex gap-0.5 text-accent-500">
                    {Array.from({ length: 5 }).map((_, x) => <i key={x} className="ri-star-fill text-xs" />)}
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}